module.exports = __webpack_public_path__ + "media/images/flags/32/Djibouti-e3d627b2ea4da128c5c7205e83e0431f.png";